const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://lacasadelpuro-pos-production.up.railway.app';
export { API_BASE_URL };

async function req(method, path, body) {
  const opts = { method, headers: { 'Content-Type': 'application/json' } };
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(API_BASE_URL + path, opts);
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const getItems = () => req('GET', '/items');
export const getCategories = () => req('GET', '/categories');
export const getOpenTabs = () => req('GET', '/tabs/open');
export const getTab = (id) => req('GET', `/tabs/${id}`);
export const openTab = (body) => req('POST', '/tabs', body);
export const addItemToTab = (tabId, body) => req('POST', `/tabs/${tabId}/items`, body);
export const closeTab = (tabId, body) => req('POST', `/tabs/${tabId}/close`, body);
export const voidTab = (tabId, reason, staffId) => req('POST', `/tabs/${tabId}/void`, { reason, staff_id: staffId });
export const searchMembers = (q) => req('GET', `/members/search?q=${encodeURIComponent(q)}`);
export const getMember = (id) => req('GET', `/members/${id}`);
export const applyCredit = (body) => req('POST', '/credits/apply', body);
export const getStaff = () => req('GET', '/staff');
export const staffLogin = (pin) => req('POST', '/staff/login', { pin });
export const getItems2 = (categoryId) => req('GET', `/items?category_id=${categoryId}`);
export const updateItem = (id, body) => req('PUT', `/items/${id}`, body);
export const createItem = (body) => req('POST', '/items', body);
export const getMembers = () => req('GET', '/members');
export const createMember = (body) => req('POST', '/members', body);
export const updateMember = (id, body) => req('PUT', `/members/${id}`, body);
export const getTransactionHistory = () => req('GET', '/tabs/history');
export const getReports = (params) => req('GET', `/reports?${new URLSearchParams(params)}`);
export const getCigars = (params) => req('GET', `/cigars?${new URLSearchParams(params)}`);

export const removeTabItem = (tabId, itemId) => req('DELETE', `/tabs/${tabId}/items/${itemId}`);
